import classNames from 'classnames';
import { FC, Fragment } from 'react';

import classes from './Gauge.module.scss';

export interface GaugeProps {
  value: number;
  title: string;
  size?: number;
  minValue?: number;
  maxValue?: number;
  steps?: number;
}

const Gauge: FC<GaugeProps> = ({
  value,
  title,
  size = 90,
  minValue = 0,
  maxValue = 260,
  steps = 10,
}) => {
  const borderWidth = 10;
  const stepLabels = [...Array(steps + 1)].map(
    (_, i) => ((maxValue - minValue) / steps) * i + minValue
  );

  const rotate = (v: number) => (270 / (maxValue - minValue)) * (v - minValue);

  return (
    <div
      className={classNames(classes.Container, { [classes.Empty]: !value })}
      style={{ height: size + 80, width: size + 80 }}
    >
      <div style={{ height: size, width: size }}>
        <div className={classes.GaugeStart} />
        <div className={classes.GaugeEnd} />
        <b>{value || 0}</b>
        <div
          className={classes.Hand}
          style={{
            transform: `translateY(-50%) rotate(${
              -45 + rotate(Math.min(value, maxValue))
            }deg)`,
            borderRightWidth: size / 2 + borderWidth,
          }}
        />
        <span />
        {stepLabels.map((v, i) => (
          <Fragment key={i}>
            <p
              style={{
                transform: `translate(-50%, -50%) rotate(${
                  -45 + rotate(v)
                }deg) translate(${-(size / 2) - borderWidth * 2.3}px) rotate(${
                  45 - rotate(v)
                }deg)`,
              }}
            >
              {value ? v : 0}
            </p>
            <div
              style={{
                transform: `translate(-50%, -50%) rotate(${
                  -45 + rotate(v)
                }deg) translate(${
                  -(size / 2) - borderWidth - borderWidth / 4
                }px)`,
              }}
              className={classes.Line}
            />
          </Fragment>
        ))}
      </div>
      <p>{title}</p>
    </div>
  );
};

export default Gauge;
